import React, { useEffect, useState } from 'react'
import styles from '@/src/components/scss/Calendar.module.scss'
import { useCalendar } from '@/components/Schedule/Calendar/CalendarProvider'
import { Timeslot, Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { Box } from '@mui/material'
import { useSchedule } from '@/components/Schedule/ScheduleRoot'

const Timeslots = () => {
  const { TZ, possibleTime, availableSlots, refreshAvailableTimeSlots } =
    useCalendar()
  const { date, time, setTime } = useSchedule()

  function handleSelect(item, idx) {
    setTime({
      idx: idx,
      start: item.start,
      end: item.end
    })
  }

  useEffect(() => {
    setTime({
      idx: -1,
      start: -1,
      end: -1
    })
  }, [date])

  return (
    <>
      <Box className={styles.timeslotWrapper}>
        {possibleTime
          .sort(function (a, b) {
            return a.start > b.start
          })
          .map((item, idx) => (
            <Timeslot
              disabled={!availableSlots[idx]}
              onClick={() => handleSelect(item, idx)}
              clicked={idx === time.idx}
              key={item.content}
              fullWidth
            >
              {new Date(
                date.year,
                date.month,
                date.date,
                item.start,
                (item.start % 1) * 60
              )
                .toTimeString()
                .substring(0, 5) +
                ' - ' +
                new Date(
                  date.year,
                  date.month,
                  date.date,
                  item.end,
                  (item.end % 1) * 60
                )
                  .toTimeString()
                  .substring(0, 5)}
            </Timeslot>
          ))}
      </Box>
      <Box className={styles.TZ} bgcolor={theme.palette.grey[100]}>
        <Typography variant="body2">
          Orka team will call you during the time block you select. All times
          are in {TZ}.
        </Typography>
      </Box>
    </>
  )
}

export default Timeslots
